import styled from "styled-components";

export const NavContainer = styled.div`
    background: var(--white);
    min-height: 98vh;
    margin: 0.3rem 1rem 0 1rem;
    border-radius: var(--border-radius);
    box-shadow: 0 5px 8px var(--box-shadow);
    overflow: hidden;
    padding: 0.5rem;
    position: fixed;
    top: 0;
    left: 0;
    transform: translate(0);
    width: 90px;
    z-index: 100;
    &.show {
        width: 15%;
        @media screen and (max-width: 992px) {
            width: 40%;
        }
    }

    .prand {
        background: var(--main-color);
        padding: 1rem;
        border-radius: var(--border-radius);
        justify-content: space-between;
        svg {
            color: var(--white);
        }
    }
    .user {
        padding: 1.2rem 2rem;
        border-radius: var(--border-radius);
        background: var(--light-gray);
        margin: 2rem 0;

        img {
            background: var(--main-color);
        }
        h4 {
            color: var(--dark-gray);
            text-transform: capitalize;
        }
        h6 {
            color: var(--gray);
        }
    }
`;

export const NavLinksContainer = styled.div`
    margin: 3rem 0 0 0;

    h5 {
        color: var(--gray);
        padding: 0.5rem 0 0 0.8rem;
        margin-bottom: 1rem;
    }
    a.active {
        Button {
            background: var(--light-sky);
            color: var(--light-blue);
        }
    }
    ul {
        list-style: none;
        &.ul {
            background: #fff;
        }
        &.dropdown {
            background: #fff;
        }
        &.show {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            li {
                margin: 0.5rem 0;
                .icon_menu {
                    font-size: 2rem;
                }
            }
        }
    }
`;

export const DropDown = styled.ul`
    position: absolute;
    top: 100%;
    width: 88%;
    margin: 0.5rem 0 1rem 1rem;
`;

export const DropDownContainer = styled.div`
    position: relative;
    width: 100%;
`;
